var scope_0 = require('/Users/aaron/Apps/fresh-pets/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22cc5d66e6c9cc8885473ce1782a5b64.js').default;
var scope_1 = require('/Users/aaron/Apps/fresh-pets/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27a263427a3f490d0ec85ca2fcbc0750.js').default;
var scope_2 = require('/Users/aaron/Apps/fresh-pets/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33a558403bca71d163349dc0c79aae4d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    